import EinsModal from 'eins-modal/src/eins-modal-plain';
import toastr from 'js-toastr';

export default () => ({
    loading: false,
    error: '',
    errors: {},
    data: {},

    close: {
        ['@click']() {
            this.hide();
        }
    },

    open() {
        const options = this.$event.detail;

        this.data = this.defaultData ?? {};
        this.errors = {};

        if(options.key) {
            this.load(options.action, options.key);
        }

        this.modal = document.getElementById('modal-' + options.target);
        this.show();
    },

    show() {
        this.modal.modal('show');
    },

    hide() {
        this.modal.modal('hide');
        
        this.data = this.defaultData ?? {};
        this.errors = {};
    },

    async load(action, key = '') {
        this.loading = true;

        if(key !== '') {
            key = '/' + key;
        }

        const response = await fetch(`/api/manager/${action}${key}`, {
            method: 'GET',
        });

        const result = await response.json();

        this.data = result.data;
        this.error = result.error;
        this.loading = false;
    },

    async remove(model, key) {
        if(! model || ! key) {
            return;
        }

        this.loading = true;

        const response = await fetch(`/api/manager/${model}/${key}`, {
            method: 'DELETE',
        });

        const result = await response.json();

        this.errors = result.errors;

        toastr.setPosition('top-right');

        if (Object.keys(this.errors).length === 0) {
            toastr.message(result.success, 'success');
            this.$dispatch('loadlist');

            if(this.hideAfterSubmit) {
                this.hide();
            }
        }
        else {
            const error = result.error !== undefined ? result.error : lex['error'];
            toastr.message(error, 'error');
        }

        this.loading = false;
    },

    async submit() {
        this.loading = true;

        const form = this.$el;
        const key = form.key ? '/' + form.key.value : '';
        const formData = new FormData(form);
        const response = await fetch(`/api/manager/${form.action.value}${key}`, {
            method: 'POST',
            body: formData,
        });

        const result = await response.json();

        this.errors = result.errors;

        toastr.setPosition('top-right');

        if (Object.keys(this.errors).length === 0) {
            toastr.message(result.success, 'success');
            this.$dispatch('loadlist');

            if(this.hideAfterSubmit) {
                this.hide();
            }
        }
        else {
            const error = result.error !== undefined ? result.error : lex['error'];
            toastr.message(error, 'error');
        }

        this.loading = false;
    },
})
